import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { OrderHistoryCommon } from './order-history.common';
import { PageBaseFull } from '../../../../core/page-base.full';
import { UserData } from '../../../../providers/user-data'; 
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
import firebase from 'firebase';
import { AccountData } from '../../providers/account-data';

@Component({
	selector: 'page-order-history-full',
	templateUrl: 'order-history.full.html'
})

export class OrderHistoryPageFull extends PageBaseFull{
	public currentUser: any;
	public submitted = false;
	public formMsg: any;
	public realtimeDb: any;
	public ordersList: any;
	constructor(
    	public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: OrderHistoryCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
		public accountData: AccountData,
    ) {	
		 super(settings, events, nav, userData);
		 console.log("Loading Order History Full");
		 this.realtimeDb = firebase.database();
    }

	ionViewDidEnter() {
		this.app.setTitle('Account > Order History');
		
	}

	ngAfterViewInit() {
		this.common.commonMethod();
		
		let self = this;
		this.userData.getUser().subscribe(user => {
			//console.log(user);
			this.currentUser = user;
			console.log(this.currentUser);
			if(this.currentUser){
				self.accountData.getOrdersData(this.currentUser.uid).subscribe(orders => {
					console.log(orders);
					self.ordersList = orders;
				});
			}
		});
	}

	public cancel(){
		this.nav.setRoot(this.pageRef.get('home'));
	}

	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/order-history/order-history.full.ts